import store from '../store'

export default function userHasNotCompletedData (to, from, next) {
  if (store.getters['user/hasCompletedTypeData']) {
    return next({
      name: 'home'
    })
  }

  return false
}
